import { useCallback } from 'react'
import { useSegwayRouter } from '@/features/shared/hooks/useSegwayRouter'
import { stringify, searchParamsToObject } from '@/features/shared/utils/queryString'

export const useShallowRouterReplace = () => {
  const router = useSegwayRouter()

  const shallowRouterReplace = useCallback(
    (additionalQuery: Record<string, unknown>, excludedKeys: string[] = []) => {
      // read the live URL at call time
      const { pathname, search } = window.location
      const query = searchParamsToObject(new URLSearchParams(search))
      excludedKeys.forEach((key) => delete query[key])

      const nextSearch = stringify({ ...query, ...additionalQuery })
      const href = nextSearch ? `${pathname}?${nextSearch}` : pathname

      return router.replace(href, { shallow: true })
    },
    [router],
  )
  return { shallowRouterReplace }
}
